import { loadExternalScript } from '../utils/scriptLoader';
import { initSocialCharts } from './charts/socialCharts';

console.log('initAll.js loaded');

let initialized = false;
let initializationPromise = null;

export async function initializeAllCharts() {
  if (initialized) {
    return;
  }

  if (initializationPromise) {
    return initializationPromise;
  }

  const bootPromise = (async () => {
    const d3 = await loadExternalScript('https://d3js.org/d3.v7.min.js', 'd3');
    const Plot = await loadExternalScript(
      'https://cdn.jsdelivr.net/npm/@observablehq/plot@0.6/dist/plot.umd.min.js',
      'Plot',
    );

    console.log('[BOOT] initializeAllCharts starting');

    const tasks = [
      {
        name: 'Social charts',
        fn: () => initSocialCharts({ d3, Plot }),
      },
    ];

    for (const task of tasks) {
      try {
        await task.fn();
        console.log(`[OK] ${task.name}`);
      } catch (error) {
        console.error(`[FAIL] ${task.name}`, error);
      }
    }

    document.querySelectorAll('svg').forEach((svg) => {
      const viewBox = svg.getAttribute('viewBox') || '0 0 750 400';
      svg.setAttribute('viewBox', viewBox);
      svg.style.width = '100%';
      svg.style.height = 'auto';
    });

    initialized = true;
  })();

  initializationPromise = bootPromise;

  try {
    await bootPromise;
  } catch (error) {
    initialized = false;
    console.error('Failed to initialize charts', error);
    throw error;
  } finally {
    initializationPromise = null;
  }
}

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  window.__vms_init = initializeAllCharts;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[BOOT] Auto-calling initializeAllCharts after DOM ready');
      initializeAllCharts().catch((e) => console.error('[BOOT FAIL] initializeAllCharts', e));
    });
  } else {
    console.log('[BOOT] Auto-calling initializeAllCharts (document ready)');
    initializeAllCharts().catch((e) => console.error('[BOOT FAIL] initializeAllCharts', e));
  }
}
